import { AuthorWithAiApiError } from '../../api/authorWithAiApi';

/** 422 selection rejections keyed by library id, for the picker row the server named. */
export function rowErrorsFrom(error: unknown): Record<string, string> {
  if (!(error instanceof AuthorWithAiApiError) || error.status !== 422) return {};
  return Object.fromEntries(error.fields.map((field) => [field.path.replace(/^Q-?/i, ''), field.message]));
}
